import React, { useState } from "react";
import { Heart } from "lucide-react";
import { useApiQuery } from "../lib/useApiQuery";
import { ProductCard } from "../components/ProductCard";
import { Loader, EmptyState } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";
import { useNavigate } from "react-router-dom";
import { getDisplayName } from "../lib/displayName";

export default function Favorites() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("products");
  const { data = { products: [], sellers: [] }, isLoading } = useApiQuery(["favorites", "mine"], "/favorites/mine");
  if (isLoading) return <Loader />;
  const products = data.products || [];
  const sellers = data.sellers || [];
  return (
    <div className="animate-fade-in-up max-w-5xl mx-auto">
      <PageHeader title="تفضيلاتي" />
      <div className="flex gap-2 mb-4">
        <button onClick={() => setTab("products")} className={`px-5 py-2.5 rounded-xl font-black text-sm ${tab === "products" ? "bg-[#FF3D5A] text-white" : "bg-white border border-[#E8EAF2]"}`}>المنتجات ({products.length})</button>
        <button onClick={() => setTab("sellers")} className={`px-5 py-2.5 rounded-xl font-black text-sm ${tab === "sellers" ? "bg-[#FF3D5A] text-white" : "bg-white border border-[#E8EAF2]"}`}>المتاجر ({sellers.length})</button>
      </div>
      {tab === "products" ? (
        products.length === 0 ? <EmptyState icon={Heart} title="لا توجد منتجات مفضلة" /> : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">{products.map((p) => <ProductCard key={p.product_id} item={p} />)}</div>
        )
      ) : (
        sellers.length === 0 ? <EmptyState icon={Heart} title="لا توجد متاجر مفضلة" /> : (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {sellers.map((s) => (
              <button key={s.user_id} onClick={() => navigate(`/seller/${s.user_id}`)} className="p-4 bg-white rounded-2xl border border-[#E8EAF2] text-center">
                <div className="w-16 h-16 rounded-full bg-[#FFE5EA] mx-auto flex items-center justify-center overflow-hidden">{s.picture_base64 || s.picture ? <img src={s.picture_base64 || s.picture} alt="" className="w-full h-full object-cover" /> : <span className="text-2xl font-black text-[#FF3D5A]">{(s.store_name || s.name || "?")[0]}</span>}</div>
                <p className="font-bold text-sm mt-2">{getDisplayName(s)}</p>
              </button>
            ))}
          </div>
        )
      )}
    </div>
  );
}
